import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles.css";
import "./theme/themes.css";
import "./theme/motion.css";
import "./i18n";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";

import App from "./App";
import { AppearanceProvider } from "./theme/AppearanceContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppearanceProvider>
      <Notifications position="top-right" />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppearanceProvider>
  </React.StrictMode>,
);
